// extracted by mini-css-extract-plugin
export default {"container":"eachServices_container__wNyin","otherDiv":"eachServices_otherDiv__sI98u"};